import { CircleInfo } from "@/icons/CircleInfo.tsx";
import { Alert } from "@mantine/core";

export function NotVerified() {
  const icon = <CircleInfo />;

  return (
    <Alert
      bd="1px dashed orange.8"
      title="Your account is not verified!"
      color="orange"
      icon={icon}
    >
      Please check your email for a verification link.
    </Alert>
  );
}
